import React, { useState } from 'react';
import AddFailedResponseModal from '../AddFailedResponseModal/AddFailedResponseModal';

const TextAreaWithLabel = ({ label, placeholder, name, id, type, value, onChange, DivclassName, onBlur, error,row_val,column_val, class_name,required, setFailedResponse }) => {

  const [addResponseClicked, setAddResponseClicked] = useState(false)
  return (
    <div className={DivclassName}>
      <label htmlFor={id} className="flex items-center gap-6 uppercase tracking-wide  text-s font-bold mb-1">
      <div>
          {label}  {required &&<span className="text-red-500">*</span>}
      </div>

        <button
        onClick={() => setAddResponseClicked(true)}
        className='bg-blue-700 text-white px-3 py-2 rounded-md'>
          Add Response
        </button>
      </label>
      <textarea
        id={id}
        type={type}
        row={row_val}
        cols={column_val}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        className={`appearance-none block w-full text-gray-700 border rounded py-2 px-2 leading-tight border-blue-600 focus:bg-white ${class_name}`}
      />
      {error && <p className="text-red-500 text-xs italic">{error}</p>}

      {addResponseClicked && <AddFailedResponseModal onSubmit={setFailedResponse} onClose={() => setAddResponseClicked(false)}/>}
    </div>
  );
  
};
TextAreaWithLabel.defaultProps = {
  class_name: '',
};

export default TextAreaWithLabel;
